export default __webpack_public_path__ + "static/media/spin-around.574c31f6.svg";